async function fetchPortalJson (endpoint) {
  var result = await fetch(`${process.env.VUE_APP_API_BASE_URL}portal/${encodeURI(endpoint)}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    },
    redirect: 'follow'
  })
  return result.json()
}

export default fetchPortalJson
